import { connect } from 'react-redux';

import { submitUpdatedGlobalConfiguration } from 'store/actions/configuratorsConfigs';

import PiiFilter from './PiiFilter';

const mapStateToProps = ({ configuratorsConfigs: { globals } }) => ({
  piiFilter: globals.pii_filter,
});

const mapDispatchToProps = dispatch => ({
  submitUpdatedGlobalConfiguration(...args) {
    dispatch(submitUpdatedGlobalConfiguration(...args));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PiiFilter);
